// @flow
'use strict';

import { connect } from 'react-redux';

import ListaNfe from './lista';

export default connect<*, *, *, *, *, *>()(ListaNfe);
